export default "__VITE_ASSET__fb77e1a4__"